class UniqueCache {
    constructor() {
        this.cache = {};
    }

    /**
     * @param {string=} scope
     * @param {object} data
     */
    set(data, scope) {
        let ref = this.cache;

        if (scope) {
            ref = this.cache[scope] || (this.cache[scope] = {});
        }

        Object.entries(data).forEach(([key, value]) => {
            if (ref[key] === undefined) {
                ref[key] = value;
            }
        });
    }

    /**
     * @param {string} key
     * @param {string=} scope
     */
    get(key, scope) {
        const value = scope ? this.cache[scope][key] : this.cache[key];

        if (value !== undefined) {
            return value;
        }

        return false;
    }
}

const instance = new UniqueCache();
export default instance;
